class RecommendedSection extends React.Component {

  componentDidMount() {
    console.log("componentDidMount");
    /* debugger;*/
    this.recommendedPosts = window.recommendedPosts;
  }

  render () {
    var titles = null;

    var content = null;
    if (!this.recommendedPosts) { return null; }

    content = this.recommendedPosts.map((post) => {

      if (this.props.isMobile) {
        return <RecommendedTitles post={post} key={post.id} />;
      } else {
        return <RecommendedCards post={post} key={post.id}
                 vertical={post.vertical}
               />;
      }
    });

    if (!this.props.isMobile) {
      content = <div className="row gutter_left" style={{marginBottom: "20px"}}>{content}</div>;
    }

    return (
      <div>

        <section className="popular_posts row">
          <div className="gutter_top">
            <h3 className="mono_heading size_24">Recommended</h3>
            {content}
          </div>
        </section>

      </div>
    );
  }
}

/* RecommendedSection.propTypes = {
 *   isMobile: React.PropTypes.bool
 * } */
